import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button, Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error'; 

function MyVerticallyCenteredModal(props) {
    // Determine if the response is success or failure
    const isSuccess = props.message && !props.message.includes('Error');
  
    return (
    <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
    >
        <Modal.Body style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', padding: '20px' }}>
        {/* Close button positioned at the top right of the modal body */}
        <Button 
            onClick={props.onHide} 
            style={{ position: 'absolute', top: '10px', right: '10px', background: 'none', border: 'none' }}
        >
            <span style={{ fontSize: '20px', cursor: 'pointer' }}>✕</span>
        </Button>
    
        <Box
            sx={{
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            flexWrap: 'wrap',  // Ensure the content wraps properly
            }}
        >
            {/* Conditionally render success or failure */}
            {isSuccess ? (
            <React.Fragment>
                {/* Left Success Icon Section */}
                <Box sx={{ marginRight: '15px', flexShrink: 0 }}>
                <CheckCircleIcon style={{ color: '#27ae60', fontSize: '40px' }} />
                </Box>
    
                {/* Right Success Text Section */}
                <Box sx={{ textAlign: 'left', flex: 1, wordWrap: 'break-word', wordBreak: 'break-all' }}>
                <Typography variant="h6" style={{ fontWeight: 'bold' }}>Transaction successful</Typography>
                <Typography variant="body2" color="textSecondary">Transaction Id:</Typography>
                <Typography variant="body2" color="textSecondary">{props.message}</Typography>
                </Box>
            </React.Fragment>
            ) : (
            <React.Fragment>
                {/* Left Failure Icon Section */}
                <Box sx={{ marginRight: '15px', flexShrink: 0 }}>
                <ErrorIcon style={{ color: '#e74c3c', fontSize: '40px' }} />
                </Box>
    
                {/* Right Failure Text Section */}
                <Box sx={{ textAlign: 'left', flex: 1, wordWrap: 'break-word', wordBreak: 'break-all' }}>
                <Typography variant="h6" style={{ fontWeight: 'bold' }}>Transaction failed!</Typography>
                <Typography variant="body2" color="textSecondary">{props.getErrorMessage(props.message)}</Typography>
                </Box>
            </React.Fragment>
            )}
        </Box>
        </Modal.Body>
    </Modal>
    );
}

export default MyVerticallyCenteredModal;